const follow = {
  isProcessing: false
}

export default follow;